export const CREATE_PROPERTY_SUCCESS_MESSAGE = 'Property created successfully'
export const UPDATE_PROPERTY_SUCCESS_MESSAGE = 'Property updated successfully'
export const DELETE_PROPERTY_SUCCESS_MESSAGE = 'Property deleted successfully'
export const DELETE_PROPERTY_VALUE_SUCCESS_MESSAGE = 'Property value deleted successfully'
